import { Descriptions, Space, Tag } from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'

import type { GpuProvider } from '../hooks/useGpuAdmin'
import { MarkupCell, SalesCell, SpotCell } from './ProviderControlCells'
import type { ProviderControls } from './useProviderControls'

function flag(on: boolean, label: string) {
  return (
    <Tag
      color={on ? 'blue' : 'default'}
    >{`${label}: ${on ? 'yes' : 'no'}`}</Tag>
  )
}

interface Props {
  provider: GpuProvider
  controls?: ProviderControls
}

export function ProviderDetails({ provider, controls }: Props) {
  const caps = provider.capabilities
  return (
    <Descriptions
      bordered
      size="small"
      column={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3 }}
      styles={{ label: { whiteSpace: 'nowrap' } }}
    >
      <Descriptions.Item label="Sales">
        <SalesCell provider={provider} controls={controls} />
      </Descriptions.Item>
      <Descriptions.Item label="Spot sales">
        <SpotCell provider={provider} controls={controls} />
      </Descriptions.Item>
      <Descriptions.Item label="Markup">
        <MarkupCell provider={provider} controls={controls} />
      </Descriptions.Item>
      <Descriptions.Item label="Live leases">
        {provider.live_leases}
      </Descriptions.Item>
      <Descriptions.Item label="Saleable offers">
        {provider.saleable_offers}
      </Descriptions.Item>
      <Descriptions.Item label="Catalog seen">
        <FormattedDate
          date={provider.catalog_last_seen_at}
          fmt="MMM d, yyyy HH:mm"
        />
      </Descriptions.Item>
      <Descriptions.Item label="Workloads">
        {caps.workloads.join(', ') || '—'}
      </Descriptions.Item>
      <Descriptions.Item label="Port protocols" span="filled">
        {caps.port_protocols.join(', ') || '—'}
      </Descriptions.Item>
      <Descriptions.Item label="Capabilities" span="filled">
        <Space size={4} wrap>
          {flag(caps.logs, 'Logs')}
          {flag(caps.events, 'Events')}
          {flag(caps.update, 'Update')}
          {flag(caps.marketplace_bids, 'Marketplace bids')}
          {flag(caps.private_registry, 'Private registry')}
          {flag(caps.spot, 'Spot')}
          {flag(caps.container_environment, 'Container env')}
          {flag(provider.api_module_loaded, 'API module loaded')}
        </Space>
      </Descriptions.Item>
    </Descriptions>
  )
}
